const delegate = (element, selector) => {
  // if element matches return element.
  if (element.matches(selector)) {
    return element;
  }

  // while there is a parentElement and the parent element
  // doesn't match the selector loop through parent selector
  while ((element = element.parentElement) && !element.matches(selector)); // eslint-disable-line

  // if element then return it.
  if (element) {
    return element;
  }

  // nothing matches, return false.
  return false;
};

Array.from(document.querySelectorAll('.dropdown')).forEach((btn) => {
  btn.addEventListener('click', (event) => {
    if (!delegate(event.target, '.children')) {
      event.preventDefault();
      btn.classList.toggle('is-active');
    }
  });
});
